import EnvironmentApi from '@grantstreet/psc-environment-api/api-client.js'
import { setEnvironment } from '@grantstreet/psc-environment/environment.js'
import { sentryException } from '../sentry.js'

export async function setupEnvironment (): Promise<string | undefined> {
  const response = await (new EnvironmentApi({ exceptionLogger: sentryException })).getEnvironment()
  setEnvironment(response?.data?.environment)
  return response?.data?.environment
}
